import { GATrackingEventPayload } from '../ga-tracking-event-payload.model';
import { GATrackingEventType } from '~shared/modules/ga-tracking/constants';
import { PriceTypes } from '~shared/modules/price-type-toggler/price-type-toggler.module';
import { GaTrackingHelpersService } from '../../utils/ga-tracking-helpers.service';
import { Product } from '~app/modules/account/modules/buy-again/models';
import { BUY_AGAIN, NUMBER_1 } from '~shared/constants';

export class GaTrackingSelectItemBuyAgainEventModel {
  constructor(
    private product: Product,
    private priceType: PriceTypes,
    private productIndex: number,
    private isBlackDealsEnabled: boolean) {
  }

  getEventType(): GATrackingEventType {
    return GATrackingEventType.SelectItem;
  }

  getPayload(): GATrackingEventPayload {
    return {
      event: this.getEventType(),
      gtmCustom: {
        ecommerce: {
          item_list_name: 'Buy Again',
          items: [
            {
              ...GaTrackingHelpersService.getItemObjectForGA4(this.product,
                this.product.bestOffer,
                this.priceType,
                false,
                GaTrackingHelpersService.getCategoriesFromBreadcrumbsFull(this.product.breadcrumbsFull),
                false,
                this.product.quantity,
                this.product.EECLabel,
                BUY_AGAIN,
                this.isBlackDealsEnabled
              ),
              index: this.productIndex + NUMBER_1
            }
          ]
        },
      }
    };
  }

}
